/* eslint-disable max-len */
import React from "react";
import Colors from "../../config/Colors";

export function EmptyStateIcon({
  height,
  width,
  viewBox = "0 0 357 217",
  svgColor,
}: CustomSVGProp) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox || "0 0 357 217"}
    >
      <circle cx="145.668" cy="80" r="80" fill="#EAECF0" />
      <circle cx="61.668" cy="20" r="8" fill="#F2F4F7" />
      <circle cx="233.668" cy="126" r="6" fill="#F2F4F7" />
      <circle cx="60.668" cy="138" r="10" fill="#F2F4F7" />
      <circle cx="245.668" cy="38" r="10" fill="#F2F4F7" />
      <circle cx="226.668" cy="11" r="7" fill="#F2F4F7" />
      <g filter="url(#filter0_dd_651_4986)">
        <path
          d="M91.7472 124.214L144.199 99.7551C146.832 98.5271 147.971 95.3968 146.743 92.7633L115.768 26.336L94.7924 18.7016L51.8777 38.713C49.2442 39.941 48.1049 43.0714 49.3329 45.7048L84.7554 121.669C85.9834 124.302 89.1138 125.442 91.7472 124.214Z"
          fill="url(#paint0_linear_651_4986)"
        />
        <path
          d="M94.793 18.7012L115.768 26.3356L101.463 33.0061L94.793 18.7012Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter1_dd_651_4986)">
        <path
          d="M116.82 106.339H174.693C177.599 106.339 179.955 103.984 179.955 101.078V27.7837L164.171 12H116.82C113.914 12 111.559 14.3555 111.559 17.2612V101.078C111.559 103.984 113.914 106.339 116.82 106.339Z"
          fill="url(#paint1_linear_651_4986)"
        />
        <path d="M164.172 12L179.956 27.7837H164.172V12Z" fill="#D0D5DD" />
      </g>
      <g filter="url(#filter2_dd_651_4986)">
        <path
          d="M146.578 99.724L199.03 124.182C201.663 125.41 204.794 124.271 206.022 121.638L236.997 55.2103L229.363 34.2349L186.448 14.2235C183.815 12.9955 180.684 14.1348 179.456 16.7683L144.034 92.7322C142.806 95.3657 143.945 98.496 146.578 99.724Z"
          fill="url(#paint2_linear_651_4986)"
        />
        <path
          d="M229.363 34.2354L236.998 55.2107L222.693 48.5402L229.363 34.2354Z"
          fill="#D0D5DD"
        />
      </g>
      <foreignObject x="109.668" y="80" width="72" height="72">
        <div
          style={{
            backdropFilter: "blur(4px)",
            clipPath: "url(#bgblur_0_651_4986_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <g data-figma-bg-blur-radius="8">
        <rect
          x="117.668"
          y="88"
          width="56"
          height="56"
          rx="28"
          fill="url(#paint3_linear_651_4986)"
        />
        <g clip-path="url(#clip1_651_4986)">
          <path
            d="M150.334 120.667L145.668 116M145.668 116L141.001 120.667M145.668 116V126.5M155.456 123.455C156.594 122.835 157.493 121.853 158.011 120.665C158.529 119.477 158.637 118.15 158.317 116.895C157.997 115.639 157.268 114.525 156.245 113.729C155.223 112.933 153.964 112.501 152.668 112.5H151.198C150.845 111.134 150.186 109.866 149.273 108.791C148.359 107.716 147.213 106.863 145.922 106.294C144.631 105.726 143.228 105.457 141.818 105.509C140.408 105.561 139.028 105.932 137.782 106.594C136.537 107.256 135.457 108.192 134.625 109.331C133.793 110.47 133.229 111.783 132.978 113.171C132.726 114.56 132.792 115.987 133.172 117.346C133.551 118.704 134.233 119.96 135.168 121.017"
            stroke="white"
            stroke-width="2.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <g clip-path="url(#clip2_651_4986)">
        <path
          d="M256.158 47.2129H103.133C101.069 47.214 99.0892 47.9042 97.6294 49.1321C96.1696 50.36 95.3489 52.025 95.3477 53.7615V171.855C95.3489 173.592 96.1696 175.257 97.6294 176.485C99.0892 177.713 101.069 178.403 103.133 178.404H256.158C258.223 178.403 260.203 177.713 261.663 176.485C263.123 175.257 263.944 173.592 263.945 171.855V53.7615C263.944 52.0249 263.123 50.3598 261.663 49.1319C260.203 47.904 258.223 47.2138 256.158 47.2129Z"
          fill="#C6C6C6"
        />
        <path
          d="M246.087 137.367H113.211C108.912 137.367 105.426 134.435 105.426 130.819V26.4763C105.426 22.8599 108.912 19.9277 113.211 19.9277H246.087C250.387 19.9277 253.873 22.8599 253.873 26.4763V130.819C253.873 134.435 250.387 137.367 246.087 137.367Z"
          fill="#F9F9F9"
        />
        <path
          d="M107.891 132.891V28.5497C107.891 24.9332 111.377 22.0011 115.676 22.0011H248.552C250.071 22.0011 251.483 22.3723 252.68 23.0046C251.304 21.1585 248.869 19.9277 246.087 19.9277H113.211C108.912 19.9277 105.426 22.8599 105.426 26.4763V130.819C105.426 133.159 106.889 135.206 109.084 136.364C108.332 135.357 107.891 134.169 107.891 132.892V132.891Z"
          fill="url(#paint4_linear_651_4986)"
        />
        <path
          d="M229.736 41.9736H129.559V46.7755H229.736V41.9736ZM229.736 60.3089H129.559V65.1108H229.736V60.3089ZM229.736 78.6483H129.559V83.4502H229.736V78.6483ZM229.736 96.9835H129.559V101.786H229.736V96.9835Z"
          fill="white"
        />
        <path
          d="M141.496 81.4844L166.669 102.658H141.496V81.4844Z"
          fill="url(#paint5_linear_651_4986)"
        />
        <path
          d="M263.946 104.405V55.6874L253.871 47.2129V104.404H263.946V104.405Z"
          fill="#C6C6C6"
        />
        <path
          d="M275.747 108.812L264.892 173.44C264.35 176.671 261.062 179.073 257.183 179.073H102.112C98.2327 179.073 94.9453 176.671 94.4026 173.44L79.7342 86.1114C79.0725 82.169 82.7096 78.6465 87.4434 78.6465H135.333C139.212 78.6465 142.499 81.0478 143.042 84.2781L144.964 95.7145C145.507 98.9455 148.794 101.347 152.673 101.347H268.039C272.771 101.347 276.409 104.869 275.747 108.812H275.747Z"
          fill="url(#paint6_linear_651_4986)"
        />
        <path
          d="M237.287 150.246H122.006C121.375 150.245 120.764 150.051 120.29 149.7C119.816 149.349 119.511 148.864 119.431 148.337L117.989 138.731C117.943 138.424 117.976 138.112 118.084 137.816C118.192 137.52 118.374 137.247 118.618 137.015C118.861 136.783 119.161 136.597 119.496 136.469C119.832 136.342 120.196 136.276 120.564 136.275H238.729C239.097 136.276 239.461 136.342 239.797 136.469C240.132 136.597 240.432 136.783 240.675 137.015C240.919 137.247 241.101 137.52 241.209 137.816C241.318 138.112 241.35 138.424 241.304 138.731L239.862 148.337C239.782 148.864 239.477 149.349 239.003 149.7C238.529 150.051 237.919 150.245 237.287 150.246Z"
          fill="#D5D5D5"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_651_4986"
          x="27.1094"
          y="12.0312"
          width="141.859"
          height="154.406"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_651_4986"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_651_4986"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_651_4986"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_651_4986"
            result="effect2_dropShadow_651_4986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_651_4986"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_651_4986"
          x="91.5586"
          y="12"
          width="108.398"
          height="134.34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_651_4986"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_651_4986"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_651_4986"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_651_4986"
            result="effect2_dropShadow_651_4986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_651_4986"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_651_4986"
          x="121.809"
          y="12"
          width="141.859"
          height="154.406"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_651_4986"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_651_4986"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_651_4986"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_651_4986"
            result="effect2_dropShadow_651_4986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_651_4986"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_0_651_4986_clip_path"
          transform="translate(-109.668 -80)"
        >
          <rect x="117.668" y="88" width="56" height="56" rx="28" />
        </clipPath>
        <linearGradient
          id="paint0_linear_651_4986"
          x1="88.6657"
          y1="124.418"
          x2="46.8662"
          y2="49.0087"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_651_4986"
          x1="113.94"
          y1="105.223"
          x2="107.927"
          y2="19.2131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_651_4986"
          x1="144.441"
          y1="97.4951"
          x2="175.34"
          y2="17.0024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E4E7EC" />
          <stop offset="1" stop-color="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_651_4986"
          x1="145.668"
          y1="60"
          x2="89.668"
          y2="116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8960" />
          <stop offset="1" stop-color="#FF62A5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_651_4986"
          x1="184.215"
          y1="82.4803"
          x2="102.621"
          y2="-14.5267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_651_4986"
          x1="158.128"
          y1="106.056"
          x2="132.913"
          y2="76.0786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C2CECE" stop-opacity="0" />
          <stop offset="0.179" stop-color="#AFBCBC" stop-opacity="0.179" />
          <stop offset="1" stop-color="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_651_4986"
          x1="177.74"
          y1="78.6465"
          x2="177.74"
          y2="179.073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EEF0F4" />
          <stop offset="0.927" stop-color="#E4E4E4" />
        </linearGradient>
        <clipPath id="clip1_651_4986">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(131.668 102)"
          />
        </clipPath>
        <clipPath id="clip2_651_4986">
          <rect
            width="196.168"
            height="165"
            fill="white"
            transform="translate(79.6562 17)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default EmptyStateIcon;
